import React from 'react';

import Track from 'utils/tracker';
import ReactTooltip from 'react-tooltip';


export class ShowLanding extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      show_loaded: false,
    }

    this.show_state_checker = setInterval(this.CheckLoadedShow.bind(this), 500);
  }
  
  componentDidMount(){
    // var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    // var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    // var isIE = /*@cc_on!@*/false || !!document.documentMode;
    // var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    // var isBlink = (isChrome || isOpera) && !!window.CSS;

    const state = this.state;
    state.show_demo_btn = (isChrome || isFirefox)? false: true;
    this.setState(state);
  }

  CheckLoadedShow(){
    if (window.DivShow === undefined ){
      return;
    }

    const loaded = window.DivShow.IsLoaded();
    const state = this.state;
    state.show_loaded = loaded;
    this.setState(state)

    if (loaded !== null){
      clearInterval(this.show_state_checker);
    }
  }

  PlayHeroShow(){
    Track.show("landing_hero: "  + this.props.show_xid);
    window.DivShow.Play(this.props.show_xid);
  }
  
  render (){
    const text = this.props.text || "Play Demo!";

    var playClass = {
      btn: " btn p-3 uppercase text-spacing-3 ",
      icon: " mx-2",
      note: " mt-2 text-tertiary small text-center ",
      note_browser: " mt-2 text-muted small center",
    }
    if (this.props.type === "small"){
      playClass = {
        btn: " btn-sm ",
        icon: " mr-2",
        note: " text-tertiary small ",
        note_browser: " text-muted small",
      }
    }

    if (this.state.show_loaded !== true){
      return (
        <div className="flex-center">
          <button className={"btn btn-light text-black btn-rounded " + playClass.btn} disabled>
            <i className={"fa fa-location-arrow " + playClass.icon}></i> ... loading show
          </button> 
        </div>
      )
    }

    return (
      <span className="">
        <div className="flex-center">
          <button onClick={this.PlayHeroShow.bind(this)} className={"btn btn-tertiary text-white btn-rounded " + playClass.btn}>
            <i className={"fa fa-location-arrow " + playClass.icon}></i>{text}
          </button>
          <div className={"" + playClass.note}>
            {/* <i className="fa fa-star mx-2"></i> */}
            <strong>Requires audio!</strong>
            {/* <i className="fa fa-star mx-2"></i> */}
          </div>
          {(this.state.show_demo_btn)? (
            <div className={"" + playClass.note_browser}><strong>NOTE:</strong> This demo may not work on your browser! Please use <strong>Chrome or Firefox</strong>.</div>
          ): ('')}

        </div>
      
      </span>
    )
  }
}



export class ShowButton extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      show_loaded: false,
    }

    this.show_state_checker = setInterval(this.CheckLoadedShow.bind(this), 500);
  }

  CheckLoadedShow(){
    if (window.DivShow === undefined ){
      return;
    }

    const loaded = window.DivShow.IsLoaded();
    const state = this.state;
    state.show_loaded = loaded;
    this.setState(state)

    if (loaded !== null){
      clearInterval(this.show_state_checker);
    }
  }

  PlayHeroShow(){
    Track.show("ShowButton: " + this.props.show_xid);
    window.DivShow.Play(this.props.show_xid);
  }
  
  render (){
    const text = this.props.text || "Play Show!";

    var playClass = {
      btn: " btn-md ",
      icon: " mx-1",
      note: " mt-2 text-tertiary small text-center ",
      note_browser: " mt-2 text-muted small center",
    }
    if (this.props.type === "small"){
      playClass = {
        btn: " btn-sm p-1",
        icon: " mr-2",
        note: " text-tertiary small ",
        note_browser: " text-muted small",
      }
    }

    if (this.state.show_loaded !== true){
      return (
        <button className={" btn btn-light btn-rounded text-black " + playClass.btn} disabled>
          <i className={"fa fa-location-arrow " + playClass.icon}></i> ... loading show
        </button> 
      )
    }

    return (
      <span className="">
        <div className="">
          <button onClick={this.PlayHeroShow.bind(this)} className={" btn btn-tertiary btn-rounded text-white " + playClass.btn}>
            <i className={"fa fa-location-arrow " + playClass.icon}></i>{text}
          </button>
        </div>
      </span>
    )
  }
}


export class ShowLink extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      show_loaded: false,
    }

    this.show_state_checker = setInterval(this.CheckLoadedShow.bind(this), 500);
  }

  CheckLoadedShow(){
    if (window.DivShow === undefined ){
      return;
    }

    const loaded = window.DivShow.IsLoaded();
    const state = this.state;
    state.show_loaded = loaded;
    this.setState(state)

    if (loaded !== null){
      clearInterval(this.show_state_checker);
    }
  }

  PlayHeroShow(e){
    e.preventDefault();

    Track.show("ShowLink: " + this.props.show_xid);
    window.DivShow.Play(this.props.show_xid);
  }
  
  render (){
    const text = this.props.text || "Show me!";
    const tip = this.props.tip || "Click to play show!";
    const btn_class = this.props.btn_class || "text-tertiary";

    if (this.state.show_loaded !== true){
      return (
        <a href="/" className={" text-muted " + btn_class} disabled>... loading show</a> 
      )
    }

    return (
      <span>
        <ReactTooltip effect="solid" html={true} />
        <a href="/" onClick={this.PlayHeroShow.bind(this)} className={btn_class} data-tip={tip} >{text}</a>
      </span>
    )
  }
}


export class ShowSup extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      show_loaded: false,
    }

    this.show_state_checker = setInterval(this.CheckLoadedShow.bind(this), 500);
  }

  CheckLoadedShow(){
    if (window.DivShow === undefined ){
      return;
    }

    const loaded = window.DivShow.IsLoaded();
    const state = this.state;
    state.show_loaded = loaded;
    this.setState(state)

    if (loaded !== null){
      clearInterval(this.show_state_checker);
    }
  }

  PlayHeroShow(e){
    e.preventDefault();

    Track.show("ShowLink: " + this.props.show_xid);
    window.DivShow.Play(this.props.show_xid);
  }
  
  render (){
    const text = this.props.text || "Show me!";
    const tip = this.props.tip || "Click to play show!";
    const btn_class = this.props.btn_class || "text-tertiary";

    if (this.state.show_loaded !== true){
      return (
        <sup><a href="/" className={" text-muted " + btn_class} disabled>... loading show</a></sup>
      )
    }

    return (
      <span>
        <ReactTooltip effect="solid" html={true} />
        <sup>
          <a href="/" onClick={this.PlayHeroShow.bind(this)} className={btn_class} data-tip={tip} >{text}</a>
        </sup>
      </span>
    )
  }
}